export default Vue => {
  Vue.component("v-date-input", () => import("./v-date-input.vue"));
};
